module.exports = __webpack_public_path__ + "static/media/studies_img_one.f501f7e5.jpg";